import axios from "axios"
import { setToken, refreshToken } from "../interceptors/jwt-interceptor"
import "../interceptors/loader-interceptor"
import "../interceptors/internal-server-interceptor"
import { apiErrorText } from "../shared/constant"
import { errorToastr } from "./error-handler"
import { navigate } from "gatsby"
import { v4 as uuidv4 } from 'uuid';
import base64 from 'base-64'
var CryptoJS = require("crypto-js");

// import { window, document } from "browser-monads"

console.log("env",process.env.ENCRYPT_KEY);

const apiUrl = process.env.GATASBY_API_URL
const paymentStatusUrl = process.env.PAYMENT_STATUS_URL

export const getIpAddress = data => {
  if (typeof window === "undefined") {
    return
  }
  else{
    return new Promise((resolve) => {
      resolve({IPv4 : aesEncryptData(uuidv4())})
    })
  }
}


export const encryptData = data => {
  if (typeof window === "undefined") {
    return
  }
  else{
    return new Promise((resolve) => {
      resolve(base64.encode(aesEncryptData(data)))
    })
  }
}

export const aesEncryptData = data => {
  if (typeof window === "undefined") {
    return
  }
  else
  return  CryptoJS.AES.encrypt(JSON.stringify(data), `${process.env.DECRYPT_KEY}`).toString();
}

export const getJWTTokenForIp = data => {
  if(refreshToken) {
    return
  }
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/generate-jwt`, data)
      .then(res => {
        if (res?.data?.accessToken && res.data?.refreshToken) {
          setToken(res.data)
          resolve(res)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const generateAccessTokenFromRefresh = (data) => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/generate-accessToken-from-refeshToken`, data)
      .then(res => {
        if (res.data?.accessToken) {
          setToken(res.data)
          resolve(res)
        }
      })
      .catch(error => {
        errorToastr("Session timed out")
        window.location.href = process.env.GATSBY_RESUME_JOURNEY_LINK
        setToken({accessToken: "", refreshToken: ""})
      })
  })
}

export const updateCounterOfferStatus = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/update-counteroffer-status`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              updateCounterOfferStatus(data)
                .then(res => {
                  console.log("update Counter Offer Status res")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const generateCounterOfferPdf = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/counter-offer-pdf-generation`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              generateCounterOfferPdf(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const generateCounterOfferRejectPdf = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/counter-offer-pdf-reject-generation`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              generateCounterOfferPdf(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const saveDropoutTimeStamp = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  // console.log("datae", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save-dropout-timestamp`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveDropoutTimeStamp(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const saveLoginTimeStamp = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  // console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save-login-timestamp`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveLoginTimeStamp(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const saveTransactionDetails = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save-transactionDetails`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveTransactionDetails(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const saveEnachTransactionDetails = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save-enachTransactionDetails`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveEnachTransactionDetails(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}


export const paymentTextDecrypt = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/payment_text_decrypt`, data)
      .then(res => {
        console.log("responceeeee", res.data,);

        let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);
        console.log("bytes", bytes);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        console.log("dcrypteddata", decryptedData);
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              paymentTextDecrypt(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const digilockerDecrypt = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/digilocker-decrypt`, data)
      .then(res => {
        console.log("responceeeee", res.data,);

        let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);
        console.log("bytes", bytes);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        console.log("dcrypteddata", decryptedData);
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              paymentTextDecrypt(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const getOTP = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/send-otp`, encryptedPayload)
      .then(res => {
        // if(apiErrorText.includes(res?.status)){
        //     errorToastr(res.MESSAGE)
        // }
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getOTP(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  if ([500, 400].includes(error?.response?.status)) {
                    errorToastr(error.response.data.message)
                  }
                  reject(error)
                })
            })
            .catch(error => {
              if ([500, 400].includes(error?.response?.status)) {
                errorToastr(error.response.data.message)
              }
              reject(error)
            })
        } else {
          if ([500, 400].includes(error?.response?.status)) {
            errorToastr(error.response.data.message)
          }
          console.log(error)
        }
      })
  })
}
export const resumeSendOTP = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/resume-journey-send-otp`, encryptedPayload)
      .then(res => {
        // if(apiErrorText.includes(res?.status)){
        //     errorToastr(res.MESSAGE)
        // }

        if (res?.data?.jwt) {
          setToken(res.data.jwt)
        }
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              resumeSendOTP(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  if ([500, 400].includes(error?.response?.status)) {
                    errorToastr(error.response.data.message)
                  }
                  reject(error)
                })
            })
            .catch(error => {
              if ([500, 400].includes(error?.response?.status)) {
                errorToastr(error.response.data.message)
              }
              reject(error)
            })
        } else {
          if ([500, 400].includes(error?.response?.status)) {
            errorToastr(error.response.data.message)
          }
          reject(error)
        }
      })
  })
}

export const verifyDeclarationOtp = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/saveDeclaration`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              verifyDeclarationOtp(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const verifyDeclarationOtpV2 = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/saveDeclarationV2`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              verifyDeclarationOtpV2(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const finalSubmission = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/final-submission`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              finalSubmission(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const getChoiceMasters = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}/choice_masters/${data.requiredMaster}`)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getChoiceMasters(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const fetchJourney = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/journey-details/fetch-journey`, encryptedPayload)
      .then(res => {
        // if(apiErrorText.includes(res?.status)){
        //     errorToastr(res.MESSAGE)
        // }
        if(res.data && res.data.encryptedData )
        {
          let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
          let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          res.data = decryptedData;
        }
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchJourney(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  if ([500, 400].includes(error?.response?.status)) {
                    errorToastr(error.response.data.message)
                  }
                  reject(error)
                })
            })
            .catch(error => {
              if ([500, 400].includes(error?.response?.status)) {
                errorToastr(error.response.data.message)
              }
              reject(error)
            })
        } else {
          if ([500, 400].includes(error?.response?.status)) {
            errorToastr(error.response.data.message)
          }
          reject(error)
        }
      })
  })
}
export const viewJourney = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/view-record`, data)
      .then(res => {
        // if(apiErrorText.includes(res?.status)){
        //     errorToastr(res.MESSAGE)
        // }
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              viewJourney(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  if ([500, 400].includes(error?.response?.status)) {
                    errorToastr(error.response.data.message)
                  }
                  reject(error)
                })
            })
            .catch(error => {
              if ([500, 400].includes(error?.response?.status)) {
                errorToastr(error.response.data.message)
              }
              reject(error)
            })
        } else {
          if ([500, 400].includes(error?.response?.status)) {
            errorToastr(error.response.data.message)
          }
          reject(error)
        }
      })
  })
}

export const saveJourney = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/journey-details/save-journey`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveJourney(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}
// export const updateJourney = (data)=>{
//     if (typeof window === "undefined") {
//         return;
//     }
//     return new Promise((resolve, reject) => {
//         axios
//             .patch("http://localhost:4004/isnp-api/journey-details/fetch-journey",
//             {
//                 data:data,
//             })
//             .then((res) => {
//                 resolve(res.data)
//             })
//             .catch((error) => {
//                 reject(error);
//             });
//     });
// }

export const saveApplication = data => {

  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save-application-details`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveApplication(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          errorToastr("Internal server error")
          return reject(error)
        }
      })
  })
}

export const fetchApplicationDetails = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    encryptData(data._id)
    .then(id => {
      axios
      .get(`${apiUrl}/fetch-application-details/${id}`)
      .then( res => {
        
       let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
       let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
       res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchApplicationDetails(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
    })
    .catch(error => {
      reject(error)
    })
    
  })
}

export const getAllInputQuotations = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/policy-all-inputs-quotation`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getAllInputQuotations(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const saveApplicationDetailsOverall = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/save-application-overall`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              saveApplicationDetailsOverall(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const fetchApplicationNumber = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/application-number-generation`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchApplicationNumber(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const dedupeCall = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/dedupe-call`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              dedupeCall(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const dedupeCallProposer = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/dedupe-call-proposer`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              dedupeCall(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const fetchAllJourneyData = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    encryptData(data.journeyId)
    .then(journeyId => {
      axios
      .get(`${apiUrl}/all-jounrey-data/${journeyId}`)
      .then(res => {
        //  console.log("responceeeee",res.data);
       let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
       let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      //  console.log("dcrypteddata",decryptedData);
       res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchAllJourneyData(data)
                .then(res => {
                  //  console.log("responceeeee",res.data);
       let bytes  =  CryptoJS.AES.decrypt(`${res?.data?.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
       let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      //  console.log("dcrypteddata",decryptedData);
       res.data = decryptedData
                  console.log(res, "sdff")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
    })
    .catch(error => {
      reject(error)
    })
  })
}

export const uploadDocument =  (formData, payload) => {
  if (typeof window === "undefined") {
    return
  }
  const encryptedQueryString = aesEncryptData(payload)
  console.log("encryptedQueryString", encryptedQueryString)
  let base64EncryptedString = base64.encode(encryptedQueryString)
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${apiUrl}/file-upload?encryptedQuery=${base64EncryptedString}`,
        formData
      )
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              uploadDocument(formData, payload)
                .then(res => {
                  console.log("upload document response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const uploadTempDocument =  (formData, payload,retry = true) => {
  if (typeof window === "undefined") {
    return
  }
  const encryptedQueryString = aesEncryptData(payload)
  console.log("encryptedQueryString", encryptedQueryString)
  let base64EncryptedString = base64.encode(encryptedQueryString)
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${apiUrl}/upload-temp-document?encryptedQuery=${base64EncryptedString}`,
        formData
      )
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(
          `${res.data.encryptedData}`,
          `${process.env.ENCRYPT_KEY}`
        )
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status) && retry) {
          let payloadRefresh = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payloadRefresh)
            .then(res => {
              uploadTempDocument(formData, payload,false)
                .then(res => {
                  console.log("upload document response")
                  resolve(res)
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              errorToastr("File not supported, please try with another file")
              reject(error)
            })
        } else {
          errorToastr("File not supported, please try with another file")
          reject(error)
        }
      })
  })
}

export const deleteTempDocument = (data) => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/delete-temp-document`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              deleteTempDocument(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
          reject(error)
        }
      })
  })
  
}

export const moveTempDocumentsToPermanentBucket = (data) => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/move-temp-documents`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              moveTempDocumentsToPermanentBucket(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          reject(error)
        }
      })
  })
}


export const generateBI = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/generate-bi`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (!res?.data.data.BIJson) {
          if (
            res?.data?.data?.InputValidationStatus &&
            res?.data?.data?.InputValidationStatus[0]?.ErrorMessage &&
            res?.data?.data?.InputValidationStatus[0]?.ErrorMessage.length > 0
          ) {
            let str = res?.data.data.InputValidationStatus[0]?.ErrorMessage.map(
              el => el.value
            ).join(",")
            errorToastr(str)
          } else if (
            res?.data?.data?.InputValidationStatus &&
            res?.data?.data?.InputValidationStatus[0]?.ErrorMessage &&
            res?.data?.data?.InputValidationStatus[0]?.ErrorMessage.length === 0 &&
            res?.data?.data?.InputValidationStatus[0]?.GeneralError
          ) {
            errorToastr(res?.data?.data?.InputValidationStatus[0]?.GeneralError)
          } else {
            errorToastr(res?.data?.data?.Message)
          }
        }
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              generateBI(data)
                .then(res => {
                  console.log("generate bi response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  if ([500, 400].includes(error?.response?.status)) {
                    errorToastr(error.response.data.message)
                  }
                  reject(error)
                })
            })
            .catch(error => {
              if ([500, 400].includes(error?.response?.status)) {
                errorToastr(error.response.data.message)
              }
              reject(error)
            })
        } else {
          if ([500, 400].includes(error?.response?.status)) {
            errorToastr(error.response.data.message)
            return
          }
          reject(error)
        }
      })
  })
}

export const checkBIExists = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/check-bi-exists`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              checkBIExists(data)
                .then(res => {
                  console.log("check bi response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const sendEmailBI = data => {
  if (typeof window === "undefined") {
    return
  }
  console.log(data, "data")
  let encryptData = aesEncryptData(data)
  console.log("encryptData", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/sendEmailBI`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              sendEmailBI(data)
                .then(res => {
                  console.log("send bi response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const sendSelectedOptions = data => {
  //provide your consent
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/provide-your-consent`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              sendSelectedOptions(data)
                .then(res => {
                  console.log("selected option response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const sendSelectedOptionsProposer = data => {
  //provide your consent
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/provide-your-consent-proposer`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              sendSelectedOptions(data)
                .then(res => {
                  console.log("selected option response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

// pnb redirect url
export const decryptUrl = data => {
  if (typeof window === "undefined") {
    return
  }

  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    axios
      .post(`${apiUrl}/decrypt-redirect-url`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`,`${process.env.ENCRYPT_KEY}`)
          let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          console.log("dcrypteddatasadasd", decryptedData.data.result);
          res.data = decryptedData.data.result
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              decryptUrl(encryptedPayload)
                .then(res => {
                  console.log("decryptUrl response")
                  if (res ) {
                    let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`,`${process.env.ENCRYPT_KEY}`)
                    let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    console.log("dcrypteddatasadasd", decryptedData.data.result);
                    res.data = decryptedData.data.result
                    resolve(res?.data)
                    // resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const fetchPincodeDetails = data => {
  if (typeof window === "undefined") {
    return
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/pincodeDetails`, data)
      .then(res => {
        resolve(res?.data)
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchPincodeDetails(data)
                .then(res => {
                  console.log("fetch pincode details response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
          reject(error)
        }
      })
  })
}

export const fetchDigilockerDetails = data => {
  if (typeof window === "undefined") {
    return
  }

  return new Promise((resolve, reject) => {
    let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
    axios
      .post(`${apiUrl}/digilockerDetails`, encryptedPayload)
      .then(res => {
        resolve(res?.data)
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchDigilockerDetails(data)
                .then(res => {
                  console.log("fetch digilocker details response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
          reject(error)
        }
      })
  })
}

export const pdfDownload = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/policy-download-pdf-quotation`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              pdfDownload(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res ) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const paymentText = data => {
  if (typeof window === "undefined") {
    return
  }

  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/payment_text`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              paymentText(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res ) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const counterOffer = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/counter-offer`, encryptedPayload)
      .then(res => {
        if(res.data && res.data.encryptedData){
          let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);
          let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          res.data = decryptedData
          resolve(res?.data)
        }else{
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              counterOffer(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const getJourneyId = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/journeyDetails-applicationNumber`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getJourneyId(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const digilocker = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/digilocker-integration`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getJourneyId(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
          reject(error)
        }
      })
  })
}

export const getS3FilenetUpload = data => {
  if (typeof window === "undefined") {
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}/s3-filenet-upload/${data}`)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getS3FilenetUpload(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const downloadPaymentReceipt = (journeyId, paymentTxnId) => {
  if (typeof window === "undefined") {
    return
  }
  let data = {
    journeyId: journeyId,
    paymentTxnId:paymentTxnId
  }

  const encryptedQueryString = aesEncryptData(data)
  console.log("encryptedQueryString", encryptedQueryString)
  let base64EncryptedString = base64.encode(encryptedQueryString)
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}/download-payment-receipt/?encryptedQuery=${base64EncryptedString}`)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              downloadPaymentReceipt(journeyId, paymentTxnId)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}
export const awsImageUrl = (proposerFormLink,applicationNo) => {
  if (typeof window === "undefined") {
    return
  }
  let data = {
    proposerFormLink: proposerFormLink,
    applicationNumber: applicationNo
  }

  const encryptedQueryString = aesEncryptData(data)
  console.log("encryptedQueryString", encryptedQueryString)
  let base64EncryptedString = base64.encode(encryptedQueryString)
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}/aws-image-url/?encryptedQuery=${base64EncryptedString}`)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(proposerFormLink)
            .then(res => {
              awsImageUrl(proposerFormLink)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const s3uploadPdfBI = data => {
  if (typeof window === "undefined") {
    return
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/pdf-upload-to-s3`, data)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              s3uploadPdfBI(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const checkDocuments = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/check-documents`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              checkDocuments(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const crifReport = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/crif-report`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              crifReport(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res && res.data) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const getDocuments = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/get-allDocuments`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const getAllTempDocuments = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  //console.log("data", encryptData);
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/get-all-temp-documents`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData;
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const checkPaymentStatus = (data) => {
  console.log(data)
  console.log("hdfkbfkjsf")
  if (typeof window === "undefined") {
    return
  }
  let finaldata = {
    srcTraceId: data
  }

  const encryptedQueryString = aesEncryptData(finaldata)
  console.log("encryptedQueryString", encryptedQueryString)
  let base64EncryptedString = base64.encode(encryptedQueryString)
  return new Promise((resolve, reject) => {
    axios
      // .get(`${paymentStatusUrl}payment/api/paymentTrackByTraceId?encryptedQuery=${base64EncryptedString}`)
      .post(`${apiUrl}/paymentStatus?encryptedQuery=${base64EncryptedString}`)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              checkPaymentStatus(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
          reject(error)
        }
      })
  })
}
export const checkPaymentStatus2 = (data) => {
  console.log(data)
  console.log("hdfkbfkjsf")
  if (typeof window === "undefined") {
    return
  }
  let finaldata = {
    applicationNumber: data
  }

  const encryptedQueryString = aesEncryptData(finaldata)
  console.log("encryptedQueryString", encryptedQueryString)
  let base64EncryptedString = base64.encode(encryptedQueryString)
  return new Promise((resolve, reject) => {
    axios
      // .get(`${paymentStatusUrl}payment/api/paymentTrackByTraceId?encryptedQuery=${base64EncryptedString}`)
      .post(`${apiUrl}/payment_Status2?encryptedQuery=${base64EncryptedString}`)
      .then(res => {
        console.log(res);
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        console.log(error?.response?.status);
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              checkPaymentStatus(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
          reject(error)
        }
      })
  })
}
export const ifscCodeDetails = data => {
  if (typeof window === "undefined"){
    return
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/ifsc-code`, data)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`,`${process.env.ENCRYPT_KEY}`)
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data){
          resolve(res?.data)
        }
      })
      .catch(error => {
        if([403].includes(error?.response?.status)){
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              ifscCodeDetails(data)
                .then(res => {
                  console.log("api success response");
                  if(res && res.data){
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service");
        }
      })
  })
  
}

export const flexiEdgeProposalForm = (data)=>  {
  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    // let encryptedPayload = aesEncryptData(data)
    console.log(encryptedPayload);
  axios
    .post(`${apiUrl}/flexiEdge-proposal-form-v2`, encryptedPayload)
    .then(res => {
      let bytes = CryptoJS.AES.decrypt(`${res.data.encryptedData}`,`${process.env.ENCRYPT_KEY}`)
      let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      res.data = decryptedData
      if (res && res.data){
        resolve(res?.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            flexiEdgeProposalForm(encryptedPayload)
              .then(res => {
                console.log("api success responseeeee");
                if(res && res.data){
                  resolve(res)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        console.log(error, "error in api service");
      }
    })
  })
}

export const fetchFnaDetails = data => {
  if(typeof window === "undefined"){
    return
  }
  return new Promise((resolve, reject) => {
    encryptData(data._id)
    .then(id => {
      axios
      .get(`${apiUrl}/fetch-fna-details/${id}`)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
         if (res && res.data) {
           resolve(res?.data)
         }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchFnaDetails(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
    })
    .catch(error => {
      reject(error)
    })
    
  })
}

export const fetchCanaraPosDetails = data => {
  if(typeof window === "undefined"){
    return
  }
  return new Promise((resolve, reject) => {
    encryptData(data._id)
    .then(id => {
      axios
      .get(`${apiUrl}/fetch-canaraPos-details/${id}`)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
         if (res && res.data) {
           resolve(res?.data)
         }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              fetchCanaraPosDetails(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
    })
    .catch(error => {
      reject(error)
    })
    
  })
}

export const physicalMandateFormPDF = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/physical-mandate-pdf`, payload);
    return response.data
  } catch(error) {
    return error?.response.data
  }
}

export const retreiveUploadedDocuments = (data)=>  {
  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    // let encryptedPayload = aesEncryptData(data)
    console.log(encryptedPayload);
  axios
    .post(`${apiUrl}/retreive-document`, encryptedPayload)
    .then(res => {
      //  console.log("responceeeee",res.data);
    //  let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
    //  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    //  console.log("dcrypteddata",decryptedData);
    //  res.data = decryptedData
      if (res && res.data) {
        resolve(res?.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            retreiveUploadedDocuments(data)
              .then(res => {
                console.log("api success responseeeee",res);
                if(res && res.data){
                  resolve(res)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        console.log(error, "error in api service");
      }
    })
  })
}

export const s3DownloadDocuments = (data)=>  {
  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    console.log(encryptedPayload);
  axios
    .post(`${apiUrl}/s3-upload-pdfB64-v2`, encryptedPayload)
    .then(res => {
       console.log("responceeeee",res.data);
     let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
     let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
     console.log("dcrypteddata",decryptedData);
     res.data = decryptedData
      if (res && res.data) {
        resolve(res?.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            s3DownloadDocuments(data)
              .then(res => {
                console.log("api success responseeeee",res);
                if(res && res.data){
                  resolve(res)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        console.log(error, "error in api service");
      }
    })
  })
}
export const finarkeinGenerateLink = (data) => {
  if (typeof window === "undefined") {
      return;
  }
  let encryptedPayload = {
    encryptData : aesEncryptData(data)
  }
  return new Promise((resolve, reject) => {
      axios
          .post(`${apiUrl}/finarkein-generate-link`, encryptedPayload)
          .then((res) => {
            let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
            let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            res.data = decryptedData
              if (res && res.data) {
                  resolve(res?.data)
              }
          })
          .catch(error => {
              if ([403].includes(error?.response?.status)) {
                  let payload = {
                      refreshToken: refreshToken
                  }
                  generateAccessTokenFromRefresh(payload)
                      .then(res => {
                        finarkeinGenerateLink(data)
                              .then(res => {
                                  console.log(res, "sdff")
                                  if (res && res.data) {
                                      resolve(res)
                                  }
                              })
                              .catch(error => {
                                  reject(error)
                              })
                      })
                      .catch(error => {
                          reject(error)
                      })
              } else {
                  reject(error)
              }
          })
  })

}

export const whatsAppOptin = (data) => {
  if (typeof window === "undefined") {
      return;
  }
  let encryptedPayload = {
    encryptData : aesEncryptData(data)
  }
  return new Promise((resolve, reject) => {
      axios
          .post(`${apiUrl}/whatsapp-opt-in-encrypt`, encryptedPayload)
          .then((res) => {
              if (res && res.data) {
                  resolve(res?.data)
              }
          })
          .catch(error => {
              if ([403].includes(error?.response?.status)) {
                  let payload = {
                      refreshToken: refreshToken
                  }
                  generateAccessTokenFromRefresh(payload)
                      .then(res => {
                        whatsAppOptin(data)
                              .then(res => {
                                  console.log(res, "sdff")
                                  if (res && res.data) {
                                      resolve(res)
                                  }
                              })
                              .catch(error => {
                                  reject(error)
                              })
                      })
                      .catch(error => {
                          reject(error)
                      })
              } else {
                  reject(error)
              }
          })
  })

}

export const finarkeinStatus = (data) => {
  if (typeof window === "undefined") {
      return;
  }
  let encryptedPayload = {
    encryptData : aesEncryptData(data)
  }
  return new Promise((resolve, reject) => {
      axios
          .post(`${apiUrl}/finarkein-status`, encryptedPayload)
          .then((res) => {
              if (res && res.data) {
                  resolve(res?.data)
              }
          })
          .catch(error => {
              if ([403].includes(error?.response?.status)) {
                  let payload = {
                      refreshToken: refreshToken
                  }
                  generateAccessTokenFromRefresh(payload)
                      .then(res => {
                        finarkeinStatus(data)
                              .then(res => {
                                  console.log(res, "sdff")
                                  if (res && res.data) {
                                      resolve(res)
                                  }
                              })
                              .catch(error => {
                                  reject(error)
                              })
                      })
                      .catch(error => {
                          reject(error)
                      })
              } else {
                  reject(error)
              }
          })
  })

}

export const resumeLinkForSendCaseToCustomer = (data) => {
  if(typeof window === "undefined"){
    return
  }
  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    axios
      .post(`${apiUrl}/resume-link-generation-canaraSas`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
         if (res && res.data) {
           resolve(res?.data)
         }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              resumeLinkForSendCaseToCustomer(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const checkResumeLinkExpiry = (data) => {
  if(typeof window === "undefined"){
    return
  }
  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    axios
      .post(`${apiUrl}/check-resume-link-expiry-q2p`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
         if (res && res.data) {
           resolve(res?.data)
         }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              checkResumeLinkExpiry(data)
                .then(res => {
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          console.log(error, "error in api service.js")
        }
      })
  })
}

export const salesConfidentialReportPdf = (data)=>  {
  return new Promise((resolve, reject) => {
    let encryptedPayload = {
      encryptData : aesEncryptData(data)
    }
    // let encryptedPayload = aesEncryptData(data)
    console.log(encryptedPayload);
  axios
    .post(`${apiUrl}/canara-pos-pdf-encrypted`, encryptedPayload)
    .then((res)=>{
      console.log("api success responseeeee");
      if(res && res.data){
        resolve(res.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            salesConfidentialReportPdf(data)
              .then(res => {
                console.log("api success responseeeee");
                if(res && res.data){
                  resolve(res.data)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        console.log(error, "error in api service");
      }
    })
  })
}

export const checkTPA = (data)=>  {
  return new Promise((resolve, reject) => {
  let encryptedPayload = {
    encryptData : aesEncryptData(data)
  }  
  axios
    .post(`${apiUrl}/check-tpa`, encryptedPayload)
    .then((res)=>{
      let bytes = CryptoJS.AES.decrypt(
        `${res.data.encryptedData}`,
        `${process.env.ENCRYPT_KEY}`
      )
      let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      res.data = decryptedData
      if (res && res.data) {
        resolve(res?.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            checkTPA(data)
              .then(res => {
                resolve(res)
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        reject(error)
      }
    })
  })
}

export const fetchTPADetails = (data)=>  {
  return new Promise((resolve, reject) => {
  let encryptedPayload = {
    encryptData : aesEncryptData(data)
  }  
  axios
    .post(`${apiUrl}/fetch-tpa-details`, encryptedPayload)
    .then((res)=>{
      let bytes = CryptoJS.AES.decrypt(
        `${res.data.encryptedData}`,
        `${process.env.ENCRYPT_KEY}`
      )
      let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      res.data = decryptedData
      if (res && res.data) {
        resolve(res?.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            fetchTPADetails(data)
              .then(res => {
                resolve(res)
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        reject(error)
      }
    })
  })
}

export const bookMedicalAppointmentHealthIndia = (data)=>  {
  return new Promise((resolve, reject) => {
  axios
    .post(`${apiUrl}/book-appointment-health-india`, data)
    .then((res)=>{
      console.log("api success responseeeee");
      if(res && res.data){
        resolve(res.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            bookMedicalAppointmentHealthIndia(data)
              .then(res => {
                if(res && res.data){
                  resolve(res.data)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        reject(error)
      }
    })
  })
}

export const bookMedicalAppointmentHealthAssure = (data)=>  {
  return new Promise((resolve, reject) => {
  axios
    .post(`${apiUrl}/book-appointment-health-assure`, data)
    .then((res)=>{
      console.log("api success responseeeee");
      if(res && res.data){
        resolve(res.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            bookMedicalAppointmentHealthIndia(data)
              .then(res => {
                if(res && res.data){
                  resolve(res.data)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        reject(error)
      }
    })
  })
}

export const bookMedicalAppointmentGowelNext = (data)=>  {
  return new Promise((resolve, reject) => {
  axios
    .post(`${apiUrl}/book-appointment-gowel-next`, data)
    .then((res)=>{
      console.log("api success responseeeee");
      if(res && res.data){
        resolve(res.data)
      }
    })
    .catch(error => {
      if([403].includes(error?.response?.status)){
        let payload = {
          refreshToken: refreshToken
        }
        generateAccessTokenFromRefresh(payload)
          .then(res => {
            bookMedicalAppointmentGowelNext(data)
              .then(res => {
                if(res && res.data){
                  resolve(res.data)
                }
              })
              .catch(error => {
                reject(error)
              })
          })
          .catch(error => {
            reject(error)
          })
      } else {
        reject(error)
      }
    })
  })
}

export const getTOFpaymentReceipt = (data) => {
  if (typeof window === "undefined") {
    return;
  }

  let finaldata = {
    applicationNumber: data
  };

  const encryptData = aesEncryptData(finaldata);

  let encryptedPayload = {
    encryptData: encryptData
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/Unified-payment-receipt`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
         if (res && res.data) {
           resolve(res?.data)
         }
      })
      .catch(error => {
        console.log(error?.response?.status);
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getTOFpaymentReceipt(data)
                .then(res => {
                  console.log("api success response");
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in api service.js");
          reject(error);
        }
      });
  });
};

export const channelJourneyCheck = (channelId, journeyId, rJourneyData) => {
  if (typeof window === "undefined") {
    return;
  }

  let data = { source : channelId, journeyIdFromStrapi : journeyId, rJourneyData };
  let encryptData = aesEncryptData(data);
  let encryptedPayload = {
    encryptData: encryptData
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/is-product-allowed`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(
          `${res.data.encryptedData}`,
          `${process.env.ENCRYPT_KEY}`
        )
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              channelJourneyCheck(channelId, journeyId)
                .then(res => {
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in api service.js");
          reject(error);
        }
      });
  });
};

export const getConfigurations = () => {
  if (typeof window === "undefined") {
    return;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}/get-configurations`)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(
          `${res.data.encryptedData}`,
          `${process.env.ENCRYPT_KEY}`
        )
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
          console.log(error, "error in api service.js");
          reject(error);
      });
  });
}


export const updateProductDetails = (updatePayload) => {
  if (typeof window === "undefined") {
    return;
  }

  let encryptData = aesEncryptData(updatePayload);
  let encryptedPayload = {
    encryptData: encryptData
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/update-product-details`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(
          `${res.data.encryptedData}`,
          `${process.env.ENCRYPT_KEY}`
        )
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              updateProductDetails(updatePayload)
                .then(res => {
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in api service.js");
          reject(error);
        }
      });
  });
};

export const updateUserTrackerDetails = (userData) => {
  if (typeof window === "undefined") {
    return;
  }
  let encryptData = aesEncryptData(userData);
  let encryptedPayload = {
    encryptData: encryptData
  };
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/update-userTracker-details`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(
          `${res.data.encryptedData}`,
          `${process.env.ENCRYPT_KEY}`
        )
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data);
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              updateUserTrackerDetails(userData)
                .then(res => {
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in updateUserTrackerDetails API service");
          reject(error);
        }
      });
  });
};



export const cpgPaymentVerification = (userData) => {
  if (typeof window === "undefined") {
    return;
  }
  let encryptData = aesEncryptData(userData);
  let encryptedPayload = {
    encryptData: encryptData
  };
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/gift-city-cpg-integration`, encryptedPayload)
      .then(res => {
        let bytes = CryptoJS.AES.decrypt(
          `${res.data.encryptedData}`,
          `${process.env.ENCRYPT_KEY}`
        )
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data);
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              cpgPaymentVerification(userData)
                .then(res => {
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in cpgPaymentVerification API service");
          reject(error);
        }
      });
  });
};

export const verifyCaptcha = (userData) => {
  if (typeof window === "undefined") {
    return;
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/verify-captcha`, userData)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const ckycSearchV2 = (userData) => {
  if (typeof window === "undefined") {
    return;
  }

  let encryptData = aesEncryptData(userData);
  let encryptedPayload = {
    encryptData: encryptData
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/ckyc-search-v2.0`, encryptedPayload)
      .then(res => {
        // let bytes = CryptoJS.AES.decrypt(
        //   `${res.data.encryptedData}`,
        //   `${process.env.ENCRYPT_KEY}`
        // )
        // let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        // res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data);
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              ckycSearchV2(userData)
                .then(res => {
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in ckycSearchV2 API service");
          reject(error);
        }
      });
  });
};


export const ckycDownloadV2 = (userData) => {
  if (typeof window === "undefined") {
    return;
  }

  let encryptData = aesEncryptData(userData);
  let encryptedPayload = {
    encryptData: encryptData
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/ckyc-download-v2.0`, encryptedPayload)
      .then(res => {
        if (res && res.data) {
          resolve(res?.data);
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              ckycDownloadV2(userData)
                .then(res => {
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in ckycDownloadV2 API service");
          reject(error);
        }
      });
  });
};

export const getConfigurationsByType = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/get-configurations-by-type`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
       res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getConfigurationsByType(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        } else {
          errorToastr("Internal server error")
          return reject(error)
        }
      })
  })
}

export const checkPaymentStatusCPG = data => {
  if (typeof window === "undefined") {
    return
  }
  let encryptData = aesEncryptData(data)
  let encryptedPayload = {
    encryptData: encryptData
  }
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/payment-status-cpg`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);        
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
       res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          }
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              checkPaymentStatusCPG(data)
                .then(res => {
                  console.log( "api sucess response")
                  if (res) {
                    resolve(res)
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        }
        else if([400].includes(error?.response?.status)){
          return reject(error)
        }
         else {
          errorToastr("Internal server error")
          return reject(error)
        }
      })
  })
}

export const getCisForm = (data) => {
  if (typeof window === "undefined") {
    return;
  }

  const encryptData = aesEncryptData(data);

  let encryptedPayload = {
    encryptData: encryptData
  }

  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/generate-and-return-cis`, encryptedPayload)
      .then(res => {
        let bytes  =  CryptoJS.AES.decrypt(`${res.data.encryptedData}`, `${process.env.ENCRYPT_KEY}`);   
        let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        res.data = decryptedData
        if (res && res.data) {
          resolve(res?.data)
        }
      })
      .catch(error => {
        console.log(error?.response?.status);
        if ([403].includes(error?.response?.status)) {
          let payload = {
            refreshToken: refreshToken
          };
          generateAccessTokenFromRefresh(payload)
            .then(res => {
              getCisForm(data)
                .then(res => {
                  console.log("api success response");
                  if (res) {
                    resolve(res);
                  }
                })
                .catch(error => {
                  reject(error);
                });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          console.log(error, "error in api service.js");
          reject(error);
        }
      });
  });
};